var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { array, fragment } from 'ember-data-model-fragments/attributes';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import { CatalogPricingType as CatalogPricingTypeProto, InventoryAlertType as InventoryAlertTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
var PricingType = /*#__PURE__*/function (PricingType) {
  PricingType["FIXED_PRICING"] = "FIXED_PRICING";
  PricingType["VARIABLE_PRICING"] = "VARIABLE_PRICING";
  return PricingType;
}(PricingType || {});
var InventoryAlertType = /*#__PURE__*/function (InventoryAlertType) {
  InventoryAlertType["INVENTORY_ALERT_TYPE_DO_NOT_USE"] = "INVENTORY_ALERT_TYPE_DO_NOT_USE";
  InventoryAlertType["NONE"] = "NONE";
  InventoryAlertType["LOW_QUANTITY"] = "LOW_QUANTITY";
  return InventoryAlertType;
}(InventoryAlertType || {});
let LocationOverride = (_dec = attr('string'), _dec2 = fragment('price-money'), _dec3 = attr('string', {
  protoEnum: CatalogPricingTypeProto
}), _dec4 = attr('boolean', {
  allowNull: true
}), _dec5 = attr('string', {
  protoEnum: InventoryAlertTypeProto
}), _dec6 = attr('number'), _dec7 = attr('string'), _dec8 = array(), _dec9 = attr('boolean'), _dec10 = attr('string'), _class = (_class2 = class LocationOverride extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "locationId", _descriptor, this);
    _initializerDefineProperty(this, "priceMoney", _descriptor2, this);
    _initializerDefineProperty(this, "pricingType", _descriptor3, this);
    _initializerDefineProperty(this, "trackInventory", _descriptor4, this);
    _initializerDefineProperty(this, "inventoryAlertType", _descriptor5, this);
    _initializerDefineProperty(this, "inventoryAlertThreshold", _descriptor6, this);
    _initializerDefineProperty(this, "priceDescription", _descriptor7, this);
    _initializerDefineProperty(this, "resourceTokens", _descriptor8, this);
    _initializerDefineProperty(this, "soldOut", _descriptor9, this);
    _initializerDefineProperty(this, "soldOutValidUntil", _descriptor10, this);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/item-variation/location-override'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "locationId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "priceMoney", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "pricingType", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "trackInventory", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "inventoryAlertType", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "inventoryAlertThreshold", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "priceDescription", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "resourceTokens", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "soldOut", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "soldOutValidUntil", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { LocationOverride as default };